import h from 'virtual-dom/h'
import { 
    displayAudioControlIfNotPlayed, stopSound, setWasPlayed, isAppleMobileDevice, setAudioPlayTimer,
    getIsPlaying, setIsPlaying 
} from '../utils/index'

export default class Renderers {
    constructor(settings) {
        this._settings = settings;
    }

    initialize(store) {
        this._store = store;
    }

    getRender() {
        return () => {
          let audioId = this._settings.TTS.ttsAudioId;
          let ttsDivId = this._settings.TTS.ttsDivId;
          let ttsCloseSoundId = this._settings.TTS.ttsCloseSoundId;
          let alwaysDisplayAudioControls = this._settings.TTS.alwaysDisplayAudioControls;
          let agentWindowTTS = this._settings.classNames.agentWindowTTS;
          let agentWindowTTSClose = this._settings.classNames.agentWindowTTSClose;
          let agentWindowTTSControl = this._settings.classNames.agentWindowTTSControl;
          var debugUI=true;
          let _this=this;
          var _audio=h('audio',
          {
            className: agentWindowTTSControl,
            attributes: {
                id: audioId,
                autoplay: 'autoplay',
                controls: 'controls'
            },
            onplay: (e) => {
                setIsPlaying(true);
                if (alwaysDisplayAudioControls) {
                    displayAudioControlIfNotPlayed(this._store, this._settings);
                }
                setWasPlayed(this._store, this._settings, true);
            },
            onsuspend: (e) => {
                // Android stops at suspend and waits for user interaction.
                displayAudioControlIfNotPlayed(this._store, this._settings);
            },
            onloadstart: (e) => {
                // iPhone stops at loadstart and waits for user interaction.
                if (isAppleMobileDevice()) {
                    setAudioPlayTimer(this._store, this._settings,setTimeout(function(){
                    displayAudioControlIfNotPlayed(_this._store, _this._settings)}, 2));
                }
            },
            onended: (e) => {
                setIsPlaying(false);
                stopSound(this._store, this._settings);
            },
            onpause: (e) => {
                setIsPlaying(false);
            },
            onstalled: (e) => {
              // sometimes iPhone stops with stalled.
              setIsPlaying(false);
              try {
                  if (isAppleMobileDevice()) {
                      displayAudioControlIfNotPlayed(this._store, this._settings);
                  }
              } catch (e) {
                  console.log('Failed to play audio...');
              }
            }
          });

          // Create close audio control div.
          var closeSoundControl =h('div', {
            className: agentWindowTTSClose,
            attributes:
            {
              id: ttsCloseSoundId
            },
            onclick: (e)=>{
              console.log('Closing audio controls...');
              stopSound();
            }
          });

          /*try {
              // Try and append to outer container.  If fails append to body.
              NIT.UI.getOuterContainer().append(tts);
          } catch (err) {
              $('body').append(tts);
          }*/

          var result=h('div', {
              id: ttsDivId,
              className: agentWindowTTS,
              style:
              {
                display: 'none'
              }
          }, [ _audio, closeSoundControl] );

          /*try {
              audio.attr('autoplay', 'autoplay');
          } catch (e) {
              // IE 9 autoplay throws error.
          }*/
          if (debugUI) {
              _audio.onabort=function (e) {
                  console.log(e.type);
              };
              _audio.oncanplay= function (e) {
                  console.log(e.type);
              };
              _audio.oncanplaythrough= function (e) {
                  console.log(e.type);
              };
              _audio.ondurationchange= function (e) {
                  console.log(e.type);
              };
              _audio.onemptied= function (e) {
                  console.log(e.type);
              };
              _audio.onended= function (e) {
                  console.log(e.type);
              };
              _audio.onerror= function (e) {
                  console.log(e.type);
              };
              _audio.onloadeddata = function (e) {
                  console.log(e.type);
              };
              _audio.onloadedmetadata = function (e) {
                  console.log(e.type);
              };
              _audio.onloadstart = function (e) {
                  console.log(e.type);
              };
              _audio.onpause= function (e) {
                  console.log(e.type);
              };
              _audio.onplay= function (e) {
                  console.log(e.type);
              };
              _audio.onplaying= function (e) {
                  console.log(e.type);
              };
              _audio.onprogress= function (e) {
                  console.log(e.type);
              };
              _audio.onratechange= function (e) {
                  console.log(e.type);
              };
              _audio.onseeked= function (e) {
                  console.log(e.type);
              };
              _audio.onseeking= function (e) {
                  console.log(e.type);
              };
              _audio.onstalled= function (e) {
                  console.log(e.type);
              };
              _audio.onsuspend= function (e) {
                  console.log(e.type);
              };
              _audio.ontimeupdate= function (e) {
                  console.log(e.type);
              };
              _audio.onvolumechange= function (e) {
                  console.log(e.type);
              };
              _audio.onwaiting= function (e) {
                  console.log(e.type);
              };
          }

          return result;
        };
    }
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/response-handler-tts/src/renderers/renderers.js